import classNames from 'classnames'
import { useMemo } from 'react'

import { AccountNoStatusEnum } from '@apps-common/config/account-no'

interface IProps {
  status: string
}

export const AccountNoStatus: React.FC<IProps> = ({ status }) => {
  const classes = useMemo(() => {
    switch (status) {
      case AccountNoStatusEnum.inactive:
        return 'bg-info text-on-info'

      case AccountNoStatusEnum.active:
        return 'bg-info text-on-info'

      case AccountNoStatusEnum.cancelled:
        return classNames('bg-error', 'text-on-error')

      case AccountNoStatusEnum.reserved:
        return 'bg-warning text-on-warning'

      case AccountNoStatusEnum.available:
        return 'bg-success text-on-success'

      default:
        return 'bg-border text-text'
    }
  }, [status])

  return (
    <div className='flex items-center justify-start'>
      <div className={classNames(classes, 'capitalize text-[0.8rem] px-2 py-1 rounded-lg min-w-[74px] text-center')}>{status}</div>
    </div>
  )
}
